import { render, staticRenderFns } from "./AddTrendingPage.vue?vue&type=template&id=253c2f1a&scoped=true&"
import script from "./AddTrendingPage.vue?vue&type=script&lang=js&"
export * from "./AddTrendingPage.vue?vue&type=script&lang=js&"
import style0 from "./AddTrendingPage.vue?vue&type=style&index=0&id=253c2f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c2f1a",
  null
  
)

export default component.exports